export default "__VITE_ASSET__COAVsxel__"